import './Cta.css';
import { AppStoreButton, GooglePlayButton } from '../StoreButtons/StoreButtons';

const ASSETS = {
  bg: `${process.env.PUBLIC_URL}/images/hero/bg.jpg`,
  qr: `${process.env.PUBLIC_URL}/images/hero/qr.png`,
};

function Cta() {
  return (
    <section id="pobierz" className="cta" aria-labelledby="cta-title">
      <div className="cta__banner">
        <div className="cta__backdrop" aria-hidden="true">
          <img className="cta__bg-image" src={ASSETS.bg} alt="" />
        </div>

        <div className="cta__inner">
          <div className="cta__copy">
            <h2 id="cta-title" className="cta__title">
              Pobierz za darmo!
            </h2>
            <div className="cta__stores">
              <AppStoreButton />
              <GooglePlayButton />
            </div>
          </div>

          <div className="cta__qr">
            <img src={ASSETS.qr} alt="Kod QR do pobrania aplikacji" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Cta;
